import { LOGIN_AUTH, LOGIN_ERROR } from './types';
import { errorHandler } from './error/errorHandler.action'
import { Url } from './constantUrl'
import * as types from './types'
import { NotificationManager } from 'react-notifications';
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus';
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod';
import axiosInstance from '../axiosInstance';

export const loginAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.SIGNINWITH_EMAIL;
    const options = {
      method: HTTP_METHOD.POST,
      ...(params && { data: params }),
      url,
    };
    return axiosInstance(options).then(response => {
        if (response.status === HTTP_STATUS.SUCCESS) {
          if(response?.data?.success === false){
            NotificationManager.error(response.data.message)
          }
            dispatch({ type: LOGIN_AUTH, payload: response })
            return response
        } else {
            return null
        }
    }).catch(errors => {
      if (errors?.response?.status === 400 || errors?.response?.status === 429) {
        const errorMessage = errors?.response?.data;
        if (errorMessage?.captcha) {
          NotificationManager.error(errorMessage.captcha[0]);
        } 
        else if(errorMessage?.message){
          NotificationManager.error(errorMessage.message);
        }
        dispatch({ type: LOGIN_ERROR, payload: errors.response });
        return errors?.response?.status === 400 || errors?.response?.status === 429 ? errors?.response : errorHandler(errors);
      } else {
        errorHandler(errors);
      }
    })
}
 
export const loginRolesAction = (languageId) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.LOGIN_ROLE + `?lang_id=${languageId}`
    let options = {
      method: HTTP_METHOD.GET,
      url: url
    };
    return axiosInstance(options).then(response => {
      if (response.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.GET_LOGIN_ROLE, payload: response })
        return response
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }
  
export const allLanguageListAction = () => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.ALL_LANGUAGE
  let options = {
    method: HTTP_METHOD.GET,
    url: url
  };
  return axiosInstance(options).then(response => {
    if (response.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_ALL_LANGUAGE_LIST, payload: response })
      return response
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}